/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, Input, Output, OnChanges, EventEmitter, ViewChildren, ViewChild } from '@angular/core';
import { trigger, state, animate, transition, style } from '@angular/animations';
import { Router } from '@angular/router';
import { LoginService } from '../../components/login/login.service';
import { CommonService } from '../../shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Menu } from '../../shared/model/sidemenu';
import { SIDE_MENU_ICONS } from '../../config/constants';
import { HomeService } from '../../components/home/home.service';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  animations: [
    trigger('panelVisibility', [
      state('open', style({
        'max-height': '100rem'
      })),
      state('collapse', style({
        'max-height': '0rem'
      })),
      transition('open => collapse', [animate('1s ease', style({ 'max-height': '0rem' }))]),
      transition('collapse => open', [animate('1s ease-in-out', style({ 'max-height': '100rem' }))])
    ]),
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({ transform: 'scaleX(0)', opacity: 0 }),
          animate('500ms', style({ transform: 'scaleX(1)', opacity: 1 }))
        ]),
        transition(':leave', [
          style({ transform: 'scaleX(1)', opacity: 1 }),
          animate('500ms', style({ transform: 'scaleX(0)', opacity: 0 }))
        ])
      ]
    )
  ]
})
export class SideMenuComponent implements OnInit, OnChanges {
  @Input() panelDisplay: any;
  @Output() menuClicked: EventEmitter<any> = new EventEmitter();
  @ViewChildren('search') search: any;
  @ViewChild('sharePopover') public popover!: NgbPopover;
  public sideMenubarItems: any = [];
  public panelState = 'collapse';
  private timer: any = null;
  private menuItems: Array<any> = [];
  public sidePanel: any;
  public selectedSubMenu: any;
  public searchAccess: any = true;
  public sharedByNames: any = [];
  public noOfBookmarksShared = 0;
  public menuIconsConstants = SIDE_MENU_ICONS;
  public appVersion: any;
  public isformuser!: boolean;
  public optionDisplay: boolean = false;
  public companyCode = '';

  constructor(private router: Router,
    private loginService: LoginService,
    private commonService: CommonService,
    private translate: TranslateService,
    private homeService: HomeService) {
    this.commonService.selectedLan.subscribe((lan: any) => {
      this.translate.use(lan);
      const userInfo = this.commonService.getUserDetails();
      if (userInfo.permissions && userInfo.permissions.menus && userInfo.permissions.menus.length) {
        this.createSideMenu(userInfo.permissions.menus, userInfo);
      }
    });
  }

  ngOnInit() {
    this.searchAccess = this.commonService.hasFeatureAccess('Distributor Detail View');
    this.sidePanel = this.panelDisplay;
    this.getUserDetails();
    this.appVersion = this.commonService.getAppVersion();
    if (!this.appVersion) {
      this.getApplicationVersion();
    }
    this.companyCode = this.commonService.getCompanyCode();
  }

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  private createSideMenu(menus: any, user: any) {
    let vm = this, obj: any, tempObj: any = {};
    vm.menuItems = [];
    setTimeout(() => {
        let fullMenuIndex: any;
        menus.forEach((element: any, index: number) => {
          if (element.code == 'FMN') {
            fullMenuIndex = index;
          }
          if (element.code !== 'PFL' && element.code !== 'FMN') {
            obj = new Menu();
            obj.code = element.code
            obj.name = this.getTranslationWithKey(element.code) || element.label || element.name;
            // if (element.code === 'PFL') {
            //   obj.name = vm.prepareUserName(user);
            // }
            if (element.code == 'BKM') {
              obj.showBadge = true;
            }
            const sideMenuIcons: any = SIDE_MENU_ICONS;
            obj.iconCls = sideMenuIcons[element.code] || '';
            obj.route = element.resource ? element.resource.uiURL : '';
            obj.id = element.id;
            tempObj[element.id] = obj;
          }
        });
        fullMenuIndex >= 0 ? menus.splice(fullMenuIndex, 1) : ''; /* Removinf No Side Menu option from menus list */

        menus.forEach((element: any) => { /* Pushing childerns to parents submenus array */
          if (element.parent) {
            tempObj[element.parent.id].subMenus.push(tempObj[element.id]);
          }
        });

        obj = JSON.parse(JSON.stringify(tempObj));
        for (const key in tempObj) { /* Removing Childrens from list, as they are already present in Parents Submenus Array */
          if (tempObj.hasOwnProperty(key)) {
            const element = tempObj[key];
            if (element.subMenus && element.subMenus.length) {
              vm.RemoveSubmenusFromMenuItems(element, obj);
            }
          }
        }

        vm.menuItems = Object.keys(obj).map(function (element) {
          return obj[element];
        });
        vm.prepareSideMenubarData();
        vm.commonService
          .getBookmarksTabType()
          .then(this.getHomeDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));

    }, 1000);
  }

  private getHomeDetailsSH(response: any) {
    const vm = this;
    this.sharedByNames = [];
    const responseMsg = response;
    const bookmarks = (responseMsg.data && responseMsg.data.bookmarks) ? responseMsg.data.bookmarks : [];
    vm.noOfBookmarksShared = 0;
    this.homeService.setRecentHomeData(responseMsg);
    bookmarks.forEach((element: any) => {
      if (element.sharedFrom && !element.shareViewed) {
        element.name = element.sharedFromFirstName + ' ' + element.sharedFromLastName;
        if (vm.sharedByNames.indexOf(element.name) <= -1) {
          vm.sharedByNames.push(element.name);
        }
        vm.noOfBookmarksShared++;
      }
    });
  }

  private RemoveSubmenusFromMenuItems(element: any, obj: any) {
    if (element.subMenus && element.subMenus.length) {
      element.subMenus.forEach((submenu: any) => {
        this.RemoveSubmenusFromMenuItems(submenu, obj);
        delete obj[submenu.id];
      });
    } else {
      delete obj[element.id];
    }
  }

  private prepareUserName(user: any) {
    const names = [],
      firstName = user ? (user.firstName ? user.firstName : '') : '';
    if (firstName) {
      names.push(firstName);
    }
    const lastName = user ? (user.lastName ? user.lastName : '') : '';
    if (lastName) {
      names.unshift(lastName);
    }
    return names.join(', ');
  }

  public restrictSpecialCharacter(event: any) {
    let k;
    k = event.keyCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  ngOnChanges(changes: any) {
    this.sidePanel = this.panelDisplay;
    setTimeout(() => {
      if (this.search && this.search.first) {
        this.search.first.nativeElement.focus();
      }
    }, 100);
  }

  public toggleSubMenus(menuItem: any) {
    this.sidePanel = true;
    this.commonService.sendPanelState(this.sidePanel);
    const newValue = this.sideMenubarItems?.map(function (eachMenu: any) {
      if (eachMenu.name === menuItem.name) {
        eachMenu.showSubMenus = !eachMenu.showSubMenus;
        if (!eachMenu.showSubMenus) {
            eachMenu.subMenus?.forEach((subMenu: any) => {
            subMenu.showSubMenus = false;
            subMenu.panelState = 'collapse';
          });
        }
      } else {
        eachMenu.showSubMenus = false;
      }
      if (eachMenu.showSubMenus) {
        eachMenu.panelState = 'open';
      } else {
        eachMenu.panelState = 'collapse';
      }
      return eachMenu;
    });

    //this.panelState = (menuItem.showSubMenus)?'open':'collapse';
    this.sideMenubarItems = newValue;
  }

  public toggleChildMenus(parentMenu: any, childMenu: any) {
    const updatedParentMenu = this.sideMenubarItems.map((parent: any) => {
        if (parent.name === parentMenu.name) {
            parent.subMenus = parent.subMenus.map((child: any) => {
                if (child.name === childMenu.name) {
                    child.showSubMenus = !child.showSubMenus;
                } else {
                    child.showSubMenus = false;
                }
                if (child.showSubMenus) {
                    child.panelState = 'open';
                } else {
                    child.panelState = 'collapse';
                }
                return child;
            });
        }
        return parent;
    });

    this.sideMenubarItems = updatedParentMenu;
  }

  public displaySidePanel(icon: any) {
    this.sidePanel = true;
    this.commonService.sendPanelState(this.sidePanel);
  }

  private prepareSideMenubarData() {
    this.sideMenubarItems = this.menuItems.map(function (eachItem) {
      eachItem['showSubMenus'] = false;
      eachItem['panelState'] = 'collapse';
      if (eachItem.name == 'Home') {
        eachItem.isActive = true;
      }
      return eachItem;
    });
  }

  public navigateToPage(submenu: any, containingMenu?: any) {
    // logic to highlight currently active sideMenu - Start
    this.sideMenubarItems.map((record: any) => {
      if (containingMenu) {
        record.isActive = record.id === containingMenu.id;
      } else {
        record.isActive = record.id === submenu.id;
      }
    });
    // logic to highlight currently active sideMenu - End
    if (this.popover) {
      this.popover.close();
    }
    if (submenu && submenu.showBadge) {
      submenu.showBadge = false;
    }
    this.commonService.sendPanelState(false);
    if (submenu && submenu.name) {
      this.selectedSubMenu = submenu.name;
    } else {
      return;
    }
    if (submenu && submenu.route) {
      if (submenu.name) {
        this.commonService.ActivatedSideSubMenu = submenu.name.split(' ')[0];
        sessionStorage.setItem("ActivatedSideSubMenu", submenu.name.split(' ')[0]);
      }
      this.router.navigateByUrl(submenu.route);
      this.menuClicked.emit('close');
    } else {
      this.menuClicked.emit(submenu.name);
    }
  }

  private getUserDetails() {
    let userInfo: any = {};
    userInfo = this.commonService.getUserDetails();
    if (!userInfo) {
      this.loginService.getUserProfileDetails()
        .then(this.getUserDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    } else {
      userInfo = this.commonService.getUserDetails();
      this.getUserDetailsSH(userInfo);
    }
  }

  private getUserDetailsSH(response: any) {
    let responseMsg = response, user = '';
    if (responseMsg) {
      this.loginService.setUser(responseMsg);
      this.commonService.setUserDetails(responseMsg);
      user = responseMsg;      
      if (responseMsg.permissions && responseMsg.permissions.menus && responseMsg.permissions.menus.length) {
        this.createSideMenu(responseMsg.permissions.menus, user);
      }
	  this.isformuser = responseMsg.formBaseLogin;
    }
  }

  public logout() {
    /* Clear out all local storage caches */
    const userLanguage: any = localStorage.getItem('userLanguage');
    localStorage.clear();
    this.navigateSideMenu();
    localStorage.setItem('systemLogout', 'true');
    localStorage.setItem('userLanguage', userLanguage);
    this.loginService.authenticateLogOutDetails()
      .then(this.getLogoutDetailsSH.bind(this), this.commonLogOutErrorHandler.bind(this));
  }

  private getLogoutDetailsSH(response: any) {
    const responseMsg = response;
    if (!responseMsg.success) {
      this.loginService.setUser('');
      this.router.navigateByUrl('\login');
    }
  }

  private commonLogOutErrorHandler(error: any) {
    if (error.status == 401) {
      this.loginService.setUser('');
      this.router.navigateByUrl('\login');
    }
  }

  public microsoftLogout(){
      /* Clear out all local storage caches */
      const userLanguage: any = localStorage.getItem('userLanguage');
      localStorage.clear();
      localStorage.setItem('systemLogout', 'true');
      localStorage.setItem('userLanguage', userLanguage);
      const location = window.location,
        hostName = location.hostname,
        protocol = location.protocol,
        port = location.port;
      if (hostName === 'localhost' || hostName === '127.0.0.1') {
        /* For local development */
        window.location.href = protocol + '//' + hostName + ':8084' + '/logout?userType=mfa';
      } else {
        /*  - For hosted env with ip address
         *   - port is defaulted to 80 incase not available
         */
        window.location.href = protocol + '//' + hostName + ':' + (port || '') + '/api/logout?userType=mfa';
      }
    }

  public navigateSideMenu() {
    this.sidePanel = !this.sidePanel;
    this.commonService.sendPanelState(this.sidePanel);
  }

  // private closePopover(menuItem) {
  //   if (menuItem.showBadge) {
  //     menuItem.showBadge = false;
  //   }
  //   this.popover.close();
  // }

  //VCE-27296 
  public getApplicationVersion() {
    this.loginService.getAppVersion().then((res: any) => {
      this.commonService.setAppVersion(res && res.appVersion);
      this.appVersion = res.appVersion;
    }, (err: any) => {})
  }
  //VCE-27296
}
